<template>
  <div>
    <load-profile />
    <b-card id="container" ref="container">
      <b-card-text class="mb-2">
        <h5>
          {{ $t("pages.chatAssignment.desc") }}
        </h5>
      </b-card-text>
      <div class="d-flex flex-row mb-4">
        <div
          class="d-flex flex-row flex-item--half border rounded px-2 py-2 mr-4 justify-content-between"
          :class="isManual ? 'border-primary' : ''"
          @click="isManual = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t("pages.chatAssignment.options.manual.title") }}</h4>
            <span>{{
              manualDesc === ""
                ? $t("pages.chatAssignment.options.manual.desc")
                : manualDesc
            }}</span>
          </div>
          <b-form-checkbox v-model="isManual" @change="isManual = true"/>
        </div>
        <div
          class="d-flex flex-row border flex-item--half rounded px-2 py-2 justify-content-between"
          :class="isAuto ? 'border-primary' : ''"
          @click="isAuto = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t("pages.chatAssignment.options.auto.title") }}</h4>
            <span>
              {{
                autoDesc === ""
                  ? $t("pages.chatAssignment.options.auto.desc")
                  : autoDesc
              }}
            </span>
          </div>
          <b-form-checkbox v-model="isAuto"  @change="isAuto = true"/>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end">
        <b-button variant="primary" @click="updateAssignment">
          {{ $t("button.saveChanges") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BFormCheckbox, BButton } from "bootstrap-vue";
import Repository from "@/repositories/RepositoryFactory";
import ChatAssignmentRespository from "@/repositories/Api/ChatAssignmentRespository";

const ChatAssignmentRepository = Repository.get("chatAssignmentRepository");

export default {
  components: {
    BCard,
    BCardText,
    BFormCheckbox,
    BButton,
  },
  data: () => ({
    isManual: false,
    isAuto: true,
    manualDesc: "",
    autoDesc: "",
  }),
  watch: {
    isManual(newValue, oldValue) {
      if (newValue) this.isAuto = oldValue;
    },
    isAuto(newValue, oldValue) {
      if (newValue) this.isManual = oldValue;
    },
  },
  async mounted() {
    await this.getAssignment();
  },
  methods: {
    async getAssignment() {
      try {
        const response = await ChatAssignmentRepository.show();
        const { data } = response.data;
        const { auto, manual, autoDescription, manualDescription } = data;
        this.isAuto = auto;
        this.isManual = manual;
        this.autoDesc = autoDescription;
        this.manualDesc = manualDescription;
      } catch (err) {
        const { data } = err.response;
        const { message } = data;
        if (message === "error.recordNotFound") await this.createAssignment();
      }
    },
    async createAssignment() {
      try {
        const payload = {
          manual: this.isManual,
          manualDescription:
            "Operators assign themselves to selected conversations.",
          auto: this.isAuto,
          autoDescription:
            "Operators are assigned automatically to conversations evenly in sequential order.",
        };
        const response = await ChatAssignmentRepository.create(payload);
        await this.getAssignment();
      } catch (err) {
        alert(err);
      }
    },
    async updateAssignment() {
      try {
        const payload = {
          manual: this.isManual,
          manualDescription: this.manualDesc,
          auto: this.isAuto,
          autoDescription: this.autoDesc,
        };
        const response = await ChatAssignmentRespository.update(payload);
      } catch (err) {
        alert(err);
      } finally {
        await this.getAssignment();
      }
    },
  },
  setup() {
    const permissionType = "chat-settings";
    return { permissionType };
  },
};
</script>

<style class="scss" scoped>
.flex-item--half {
  cursor: pointer;
  width: 100%;
  max-width: 50%;
}
</style>
